import { useEffect, type FC } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import Header from '@components/header';
import styles from './index.module.scss';
import { useInitVaultCoins } from '@hooks/use-coins';
import Transaction from '@components/transaction';
import Lottie from 'lottie-react';
import flyJSON from '@assets/lottie/vault/fly.json';
import Footer from '@components/footer';
import './global.module.scss';
import { notification } from 'antd';

notification.config({
  maxCount: 3,
  placement: 'topRight',
  rtl: false,
});

const App: FC = () => {
  const { pathname } = useLocation();
  const coins = useInitVaultCoins();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <ScrollRestoration />
      {!coins ? (
        <div className={styles.loading}>
          <Lottie animationData={flyJSON} autoplay loop className={styles.lottie} />
        </div>
      ) : (
        <>
          <Header />
          <div className={styles.body}>
            <Outlet />
          </div>
          <Footer />
        </>
      )}

      <Transaction />
    </>
  );
};

export default App;
